import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import Switch from "react-switch";
import { Row, Col } from 'react-bootstrap'
import './styles.scss'

export class Main extends React.Component{
    state={
        error: false,
        signin: true,
        darkTheme: false
    }
    

    componentDidMount(){    
        document.title= "Postavke"   
    }

    handleColapsed(){    
        this.props.toggleSettings("ASIDE_COLAPSED")
    }

    handleBG() {
        this.props.toggleSettings("ASIDE_BG")
    }

    changeTheme = async () => {
        this.setState({
            darkTheme: !this.state.darkTheme
        })

        await this.props.toggleSettings("DARK_THEME_TOGGLER")

        document.documentElement.className = "";
        

        if(this.props.darkTheme){
            document.documentElement.classList.add(`theme-dark`);
        }
        else{
            document.documentElement.classList.add(`theme-light`);
        }
      
       
       
      };

    render(){  
        
        return(     
            <main style={{height: "auto"}}>
                <header>
                    <h1>
                        POSTAVKE
                    </h1>
                </header>
                <div>
                    <div >
                        <h2 style={{width: "200px", borderBottom: "1px solid lightgray"}}>Izbornik</h2>         
                    </div>
                    <br/>
                    <div>
                        <Row >
                            <Col style={{display: "inline-flex"}}>
                                <Switch onChange={(e) => this.handleColapsed(e)} checked={this.props.asideColapsed} />
                                <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Bez Naziva</h3>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col style={{display: "inline-flex"}}>
                                <Switch onChange={() => this.handleBG()} checked={this.props.asideBg} />
                                <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Pozadinska slika</h3>
                            </Col>
                        </Row>

                        <br/>

                        <Row>
                            <Col style={{display: "inline-flex"}}>
                                <Switch onChange={(e) => this.changeTheme(e)} checked={this.props.darkTheme} />
                                <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Tamna tema</h3>
                            </Col>
                        </Row>

                        <br/>
                        {/*}
                        <select defaultValue={() => this.state.theme} onChange={(e) => this.changeTheme(e)}>
                            {themes.map((theme, index) => (
                                <option value={theme} key={index}>
                                {theme}
                                </option>
                            ))}
                        </select>
                            */}
                    </div>
    
                </div>
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        asideColapsed: state.user.asideColapsed,
        asideBg: state.user.asideBg,
        darkTheme: state.user.darkTheme
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data}),
      toggleSettings: (type) => dispatch({ type: type})  
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main);
